<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box configuracion">
  <h3>{{ title }}</h3>
  <hr />

  <div class="row mt-4 pasos">
    <div class="col-12 d-flex justify-content-sm-center">
      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--active d-flex justify-content-sm-center align-items-center"
        >
          <span>1</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--active text-center mt-2">
            Nombre y ponderación
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>2</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Bloques y rubros</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>3</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">preguntas</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>4</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Tipo de respuesta
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>5</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Configuración de respuestas
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>6</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Reglas de negocio
          </p>
        </div>
      </div>
    </div>
  </div>

  <form
    id="formPostPaso1"
    (submit)="formPostPaso1($event)"
    ngNativeValidate
  >
    <div class="row mt-5">
      <div class="col col-md-6">
        <div class="form-group">
          <label>Nombre:</label>
          <input
            required
            type="text"
            class="form-control"
            id="Nombre"
            value="{{ item.Nombre }}"
            maxlength="128"
          />
        </div>
      </div>
      <div class="col col-md-6">
        <div class="form-group">
          <label>Ponderación:</label>
          <input
            required
            type="number"
            class="form-control"
            id="Ponderacion"
            value="{{ item.Ponderacion }}"
            min="1"
            max="100"
            readonly
          />
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col text-right">
        <button type="submit" class="btn btn-sm btn-primary mr-1">
          <i class="fa fa-save"></i> Guardar y continuar
        </button>
        <a
          *ngIf="item.IdChecklist > 0"
          class="btn btn-sm btn-primary"
          routerLink="../../../ChecklistPaso2/{{ item.IdChecklist }}/{{ idTipoRevision }}"
          ><i class="fa fa-arrow-right"></i> Continuar</a
        >
      </div>
    </div>
  </form>
</div>
